import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M18 7a2 2 0 1 1 4 0v10a2 2 0 1 1-4 0zm-3-2a2 2 0 0 0-2 2v4.157a2 2 0 0 0-.768-.86L5.048 5.876C3.716 5.056 2 6.014 2 7.579v8.842c0 1.564 1.716 2.523 3.048 1.703l7.184-4.42a2 2 0 0 0 .768-.86V17a2 2 0 1 0 4 0V7a2 2 0 0 0-2-2"
    }
  )
);
var SvgPlayPauseFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PlayPauseFilled_default = SvgPlayPauseFilled;

export { PlayPauseFilled_default as default };
